import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Routes } from '../../../enums/Routes';
import classes from '../SurveysPage.module.css';

type SurveyTabsProps = {
  surveyCount?: number;
  plannedCount?: number;
};

/** Fanene er lenker, så hver visning har sin egen adresse. NavLink setter aria-current. */
export const SurveyTabs = ({ surveyCount, plannedCount }: SurveyTabsProps) => {
  const { t } = useTranslation();
  const tabs = [
    { to: Routes.CurrentSurveys, label: t('surveys.page.tabs.surveys'), count: surveyCount },
    { to: Routes.PlannedSurveys, label: t('surveys.page.tabs.planned'), count: plannedCount },
  ];

  return (
    <nav aria-label={t('surveys.page.tabsLabel')}>
      <ul className={classes.tabs}>
        {tabs.map((tab) => (
          <li key={tab.to}>
            <NavLink to={tab.to} className={classes.tab}>
              {tab.label}
              {tab.count !== undefined && <span className={classes.tabCount}>{tab.count}</span>}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};
